require('./app.scss');

let landingPicture = document.querySelector('.ux__landing--picture'),
    landingPictureWarp = document.querySelector('.ux__header--index'),
    screenHeight = document.documentElement.clientHeight + 1;
if (landingPicture) {
    landingPicture.style.height = screenHeight + 'px';
    landingPictureWarp.style.height = screenHeight + 'px';
}


let $burger = document.querySelector('.burger'), $nav = document.querySelector('.ux__nav');
$burger.addEventListener('click', function (e) {
    if ($nav.classList.contains('ux__nav--open')) {
        $nav.classList.remove('ux__nav--open')
    } else {
        $nav.classList.add('ux__nav--open')
    }
    if ($burger.classList.contains('burger--open')) {
        $burger.classList.remove('burger--open')
    } else {
        $burger.classList.add('burger--open')
    }
})


import modal from './modal';

if (location.hash.indexOf('#comment-') != -1) {
    new modal({
        title: '提交成功',
        $content: '<strong>我们将会为你匹配导师联系你！</strong>',
        footerClass: 'hide'
    }).show()

}

let contactModalHtml = `

<form class="form--contact" method="post" action="/contact/comment" role="form">

                            <p>
                                <label for="author" class="required">姓名</label>
                                <input type="text" name="author" id="author" class="text" value="" required="">
                            </p>
                            <p>
                                <label for="mail" class="required">联系邮箱</label>
                                <input type="email" name="mail" id="mail" class="text" value="" required="">
                            </p>
                            <p>
                                <label class="required" for="url">咨询原因</label>
                                <input type="text" name="url" id="url" class="text" placeholder="" value="" required="">
                            </p>
                                                        <p>
                                <label for="textarea" class="required">个人情况说明</label>
                                <textarea rows="8" cols="50" name="text" id="textarea" class="textarea" required=""></textarea>
                            </p>
                            <p class="text-right">
                                <button type="submit" class="btn btn--primary submit">提交</button>
                            </p>
                        </form>
`;
new modal({
    title: '咨询我们',
    subtitle: '简单几步填写信息，我们将会为你匹配导师联系你！',
    ele: 'ux__consult-btn',
    $content: contactModalHtml,
    footerClass: 'hide',
    shown: function () {
        var $form = document.querySelector('.form--contact');
        if ($form) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = '_';
            input.value = window._
            $form.appendChild(input)

        }

    }
})


// WEBPACK FOOTER //
// ./app.js